import { useState } from 'react'

import { EMPTY_LIST } from '../../../constants/common'
import { getObjectsSum } from '../../../utils/common'
import { CHART_DEFAULT_NAME_KEY, PIE_CHART_COLORS } from '../Chart.constants'
import { getChartValueWithShare } from '../Chart.utils'
import { ChartLegend } from '../ChartLegend'
import { ChartPie } from '../ChartPie'
import { ChartTooltip } from '../ChartTooltip'

import { CHART_DONUT_PIE_PROPS } from './ChartDonut.constants'
import { getChartDonutLegendItems } from './ChartDonut.utils'

import * as styles from './ChartDonut.module.css'

function ChartDonut({
  colors = PIE_CHART_COLORS,
  items = EMPTY_LIST,
  nameKey = CHART_DEFAULT_NAME_KEY,
  total = getObjectsSum(items),
}) {
  const [activeItem, setActiveItem] = useState(null)

  function handleSectorEnter(sector) {
    setActiveItem(sector.payload)
  }

  function handleSectorLeave() {
    setActiveItem(null)
  }

  return (
    <div className={styles.container}>
      <div className={styles.wrap}>
        <div className={styles.pie}>
          <ChartPie
            colors={colors}
            data={items}
            legendProps={null}
            nameKey={nameKey}
            pieProps={{
              ...CHART_DONUT_PIE_PROPS,
              onMouseEnter: handleSectorEnter,
              onMouseLeave: handleSectorLeave,
            }}
            tooltipProps={null}
          />
          {activeItem ? (
            <ChartTooltip
              className={styles.tooltip}
              rows={[
                {
                  id: activeItem[nameKey],
                  value: getChartValueWithShare(activeItem.value, total),
                },
              ]}
              title={activeItem[nameKey]}
            />
          ) : null}
        </div>
        <ChartLegend
          className={styles.legend}
          items={getChartDonutLegendItems({ colors, items, nameKey, total })}
        />
      </div>
    </div>
  )
}

export default ChartDonut
